module.exports = __webpack_public_path__ + "images/common_btn_s.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/common_btn_s.png
// module id = 844
// module chunks = 124